"use strict";

define('model/checklist',['./base', 'datakit/util/url'], function (BaseModel, url) {
  var Checklist = BaseModel.extend({
    childModels: {
      'responsiblePersons': 'Person'
    }
  }, {
    allOpen: function allOpen(id) {
      return this.createCollection('/rs/api/form/checklists/open/submission/:documentId').params({
        documentId: id
      });
    },
    allHistorical: function allHistorical(id) {
      return this.createCollection('/rs/api/form/checklists/submission/:documentId').params({
        documentId: id
      });
    },
    allPDFLink: function allPDFLink(id) {
      return url.template('/rs/api/form/checklist/all/:documentId/pdf', {
        documentId: id
      });
    },
    onePDFLink: function onePDFLink(id) {
      return url.template('/rs/api/form/checklist/:documentId/pdf', {
        documentId: id
      });
    }
  });
  return Checklist;
});

